import { enumToEnumNames } from '@commonClient2/services/enums';

// eslint-disable-next-line import/prefer-default-export
const DRAFT = 'Draft';
const SCHEDULED = 'Scheduled';
const ACTIVE = 'Active';
const CLOSED = 'Closed';
const PUBLISHED = 'Published';
const CANCELED = 'Canceled';

export const BidProfileStatus = Object.freeze({
    [DRAFT]: -1,
    [SCHEDULED]: 0,
    [ACTIVE]: 1,
    [CLOSED]: 2,
    [PUBLISHED]: 3,
    [CANCELED]: 4,
});

export const BidProfileStatusNames = enumToEnumNames(BidProfileStatus);
export default BidProfileStatus;
